import React from "react";
import PropTypes from "prop-types";

import Textlink from "../components/link/Textlink";
import ListItem from "../components/list/ListItem";

const Quickaccess = ({
  heading = "Schnelleinstieg über Leasingrate",
  quickLinks,
}) => (
  <div className="page-container px-5 py-10 my-4">
    <h2 className="headline--6 mb-2">{heading}</h2>
    <ul className="list-reset flex flex-wrap">
      {quickLinks.map(link => (
        <ListItem
          key={link.label}
          classNames={["w-1/2", "sm:w-1/3", "md:w-1/4", "lg:w-1/5", "xl:w-1/6"]}
        >
          <Textlink to={link.href || ""} large>
            {link.label}
          </Textlink>
        </ListItem>
      ))}
    </ul>
  </div>
);

Quickaccess.propTypes = {
  heading: PropTypes.string,
  quickLinks: PropTypes.array,
};

export default Quickaccess;
